import React from 'react';
import classes from './TagsFilter.module.css';
import TagSelector from 'containers/UI/Tags/TagSelector/TagSelector';

const tagsFilter = (props) => {
  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);
  return (
    <div className={containerClasses.join(' ')}>
      <TagSelector
        type="LogsFilter"
        readOnly
        placeholder="Select Tag(s)"
        tagsLoaded={props.tags.loaded}
        whatTagsList={props.tags.WhatTags.filter((tag) => !props.selectedTags.whatTags.includes(tag))}
        whoTagsList={props.tags.WhoTags.filter((tag) => !props.selectedTags.whoTags.includes(tag))}
        locationTagsList={props.tags.LocationTags.filter((tag) => !props.selectedTags.locationTags.includes(tag))}
        selectedWhatTags={props.selectedTags.whatTags}
        selectedWhoTags={props.selectedTags.whoTags}
        selectedLocationTags={props.selectedTags.locationTags}
        tagCategory="whatTags"
        updateTags={props.updateTags}
      />
      <div className={classes.Controls}>
        <p onClick={props.clear}>Clear</p>
        <p onClick={props.submit}>SAVE</p>
      </div>
    </div>
  );
};

export default tagsFilter;
